import {useLicenses} from '../../provider/license/license-hook';
import {HelpLinkFeatureFlagEnum} from '../feature-flags/feature-flag-const';
import {useFeatureFlag} from '../feature-flags/use-feature-flag';
import {FeaturesEnum} from '../user/user-type';

// AI photo quality (AI-28) is hidden for everyone by default: it shows only when the
// staged-rollout feature flag is on AND the brand holds the Pro licence (entitlement).
export function useAiQualityEnabled(): boolean {
    const isFlagOn = useFeatureFlag(HelpLinkFeatureFlagEnum.aiPhotoQuality);
    const {licenses} = useLicenses();
    const isProActive = Boolean(licenses[FeaturesEnum.photoToolPro]?.isActive);

    return isFlagOn && isProActive;
}
